const FILE_NAME_MAP: Record<string, string> = {
  '3d-printer': '3D Printers',
  'indigo-digital-press': 'Indigo Printers',
  scitex: 'Scitex Printers',
  'pagewide-web-press': 'PageWide Industrial presses',
  'large-format-printer': 'Large Format Printers',
  'personal-systems': 'Printer and PC Data',
  cdm: 'Printer and PC Data',
  ledm: 'Legacy Printer Data',
  ampv: 'HP Laser Printers'
} as const;

export const getFileName = (category: string, format: string): string => {
  return FILE_NAME_MAP[category] || FILE_NAME_MAP[format] || '';
};
